import {api} from '../../contexts/AuthContext';

export const categoriesApi = {
    getAll: async (): Promise<{ id: number; title: string }[]> => {
        const response = await api.get('/api/categories');
        return response.data.categories;
    }
};
